define([
	"dojo/_base/declare",
	"dijit/Menu",
	"dijit/MenuItem",
	"dijit/form/ComboButton",
	"csi/locale",
	"./ToolbarPlugin"
], function(declare,Menu,MenuItem,ComboButton,locale,ToolbarPlugin) {

	return declare([ComboButton, ToolbarPlugin], {
		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		startup: function () {
			var self = this;

			if (this._started) {
				return;
			}

			this.dropDown = new Menu();
			this.dropDown.addChild(new MenuItem({
				label: locale.resource("ViewPrintPreview"),
				onClick: function(e) {
					self.onClick(e, null, {bPrintPreview: true});
				}
			}));

			this.inherited(arguments);
		}
	});
});